import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import $ from 'jquery'
import 'parsleyjs'
import 'tinymce'
import 'tinymce-i18n/langs/pl.js'
import _ from 'lodash'
import { SketchPicker } from 'react-color'
import { Editor } from '@tinymce/tinymce-react'
import Dropzone from './Dropzone'
import Gallery from './Gallery'
import Tags from './Tags'
import Roles from './Roles'
import BaremList from './BaremList'
import AdditionalFields from './AdditionalFields'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { options: [], id: 0, preloader: true, repeat: "", passerr: false }
    this._bind('handleInputChange', 'handleEditorChange', 'onImageChange', 'fillOptions', 'add', 'save', 'onTagsChange', 'additionalFieldsChange', 'onBaremChange', 'getData', 'onRoleChange', 'handlePassChange', 'countMin', 'countMax')
  }

  componentWillMount() {
    this.props.data.fields.map((item, i) => {
      this.setState({
        [item.name]: ""
      })

      return null
    })
  }

  componentDidMount() {
    let url = this.props.data.table === "user" ? this.props.API+"/api/admin/user/list/" : this.props.API+"/api/admin/data/list/"+this.props.data.table
    let params = { "start" : 0, "stop" : 999 }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      if (result.data.status) {
        let single = _.filter( result.data.result, { id: this.props.match.params.id } )[0] || []
        this.props.data.fields.map((item, i) => {
          if (single[item.name]) {
            this.setState({
              [item.name]: single[item.name]
            })
          }

          return null
        })
        this.setState({ id: single.id, preloader:false })
        if (this.props.user.role !== "Administrator" && this.props.user.role !== "Moderator") {
          let elements = document.querySelectorAll("input, textarea, select")
          elements.forEach((element) => {
            element.disabled = true
          })
        }
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.data.flag === "E_NO_AUTH" ? "Nie masz uprawnień." : "Coś poszło nie tak." }}), true);
        this.props.history.push("/")
      }
    }, (error) => {
      console.log(error)
    })
  }

  getData() {
    let url = this.props.data.table === "user" ? this.props.API+"/api/admin/user/list/" : this.props.API+"/api/admin/data/list/"+this.props.data.table
    let params = { "start" : 0, "stop" : 999 }
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        body: JSON.stringify(params)
      })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      if (result.data.status) {
        let single = _.filter( result.data.result, { id: this.props.match.params.id } )[0] || []
        this.props.data.fields.map((item, i) => {
          if (single[item.name]) {
            this.setState({
              [item.name]: single[item.name]
            })
          }

          return null
        })
        this.setState({ id: single.id, preloader:false })
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.data.flag === "E_NO_AUTH" ? "Nie masz uprawnień." : "Coś poszło nie tak." }}), true);
        this.props.history.push("/")
      }
    }, (error) => {
      console.log(error)
    })
  }

  fillOptions(method) {
    if (method === "template") {
      this.setState({ options: this.props.templates, preloader: false })
    } else {
      let data  = {"type" : method, "params" : {}, "session_id" : this.props.sessionId}
      fetch("/api/app.php", {
        method: "POST",
        body: JSON.stringify(data)
      })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        //console.log(result)
        let res = result.result
        if (res === null) {
          res = []
        }
        this.setState({ options: res, preloader: false })
      }, (error) => {
        console.log(error)
        this.setState({ preloader: false })
      })
    }
  }

  handleInputChange(event, editor) {
    const target = event.target
    let value
    if(target.type === 'checkbox') {
      value = target.checked ? "1" : "0"
    } else {
      value = target.value
    }
    let name = target.name

    this.setState({
      [name]: value
    })
  }

  handleEditorChange(name, content) {
    let value = content

    this.setState({
      [name]: value
    })
  }

  onImageChange(name, image) {
    let value = image

    this.setState({
      [name]: value
    })
  }

  handlePassChange(event) {
    const target = event.target
    let value = target.value
    let name = target.name

    this.setState({
      [name]: value
    })
  }

  onTagsChange(tags) {
    this.setState({ productList: tags })
  }

  onBaremChange(barems) {
    this.setState({ baremList: barems })
  }

  additionalFieldsChange(data) {
    if (data !== this.state.additional_fields) {
      this.setState({ additional_fields: data })
    }
  }

  add(e) {
    e.preventDefault()

    if (this.props.data.table === "user") {
      if (this.state.password !== this.state.repeat) {
        this.setState({ passerr: true })
      } else {
        this.setState({ passerr: false })
      }

      if($('.fields').parsley().validate() && (this.state.password === this.state.repeat)) {
        this.save()
      }
    } else {
      if($('.fields').parsley().validate()) {
        this.save()
      }
    }
  }

  onRoleChange(e) {
    const target = e.target
    let value = []
    value.push({ id: parseInt(e.target.value, 10) })
    let name = target.name

    this.setState({
      [name]: value
    })
  }

  save() {
    this.setState({ preloader: true })
    let params = this.state
    let url = this.props.data.table === "user" ? this.props.API+"/api/admin/user/update/" : this.props.API+"/api/admin/data/update/"+this.props.data.table
    fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      //console.log(result)
      this.setState({ confirm: false, itemId: null, preloader: false })
      this.getData()
      if (result.data.status === false) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.error}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie zaktualizowano."}}), true);
      }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak."}}), true);
      this.setState({ preloader: false })
    })
  }

  countMin(name, from, e) {
    e.preventDefault()
    let items = []

    for (var i = 0; i < this.state.baremList.length; i++) {
      items.push(parseInt(this.state.baremList[i][from]))
    }

    let min = Math.min(...items)

    this.setState({ [name]: min })
  }

  countMax(name, from, e) {
    e.preventDefault()
    let items = []

    for (var i = 0; i < this.state.baremList.length; i++) {
      items.push(parseInt(this.state.baremList[i][from]))
    }

    let max = Math.max(...items)

    this.setState({ [name]: max })
  }

  render () {
    let fields = this.props.data.fields.map((item, i) => {

      if (item.dependOn) {
        if (!(this.state[item.dependOn.name] === item.dependOn.value)) {
          return
        }
      }

      if (item.type === "text") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="text" name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }/>
          </div>
        )
      } else if (item.type === "subtitle") {
        return (
          <div key={ i } className="title">
            <h2>{ item.value }</h2>
          </div>
        )
      } else if (item.type === "smallSubtitle") {
        return (
          <div key={ i } className="title">
            <h3>{ item.value }</h3>
          </div>
        )
      } else if (item.type === "number") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="number" name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }/>
          </div>
        )
      } else if (item.type === "checkbox") {
        return (
          <div key={ i } className="checkbox">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="checkbox" id={ i } name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } checked={ this.state[item.name] === "1" ? true : false }/>
            <label htmlFor={ i }></label>
          </div>
        )
      } else if(item.type === "option") {
        let options = []
        if (item.optionMethod === "template") {
          options = this.state.options.map((itemj, j) => {
            return (
              <option key={ j } value={ itemj.id } required={ item.required ? true : false }>{ itemj.name }</option>
            )
          })
        } else if (this.state.options.length > 0) {
          options = this.state.options.map((itemj, j) => {
            return (
              <option key={ j } value={ itemj.id } required={ item.required ? true : false }>{ itemj.title }</option>
            )
          })
        } else {
          options = item.options.map((itemj, j) => {
            return (
              <option key={ j } value={ itemj.value } required={ item.required ? true : false }>{ itemj.name }</option>
            )
          })
        }

        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <select name={ item.name } onChange={ this.handleInputChange } value={ this.state[item.name] }>
              <option value="0">Wybierz</option>
              { options }
            </select>
          </div>
        )
      } else if(item.type === "textarea") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <textarea name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }></textarea>
          </div>
        )
      } else if(item.type === "tinymce") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <Editor id={ item.name } value={ this.state[item.name] } init={{ 
              language: 'pl', 
              force_br_newlines : true,
              force_p_newlines : false,
              forced_root_block : '', 
              removed_menuitems: 'newdocument',
              plugins: 'searchreplace autolink directionality visualblocks visualchars image link media table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor imagetools contextmenu colorpicker textpattern', toolbar1: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat' }} 
              onEditorChange={ this.handleEditorChange.bind(null, item.name) } 
              required={ item.required ? true : false }/>
          </div>
        )
      } else if(item.type === "color") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <SketchPicker id={ item.name } color={ this.state[item.name] } onChangeComplete={ (e) => { this.setState({ [item.name]: e.hex }) } }/>
          </div>
        )
      } else if(item.type === "image") {
        let img = ""

        if (this.state[item.name] !== "") {
          img = this.state[item.name]
        }

        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <Dropzone image={ img } name={ item.name } onImageChange={ this.onImageChange } sessionId={ this.props.sessionId }/>
          </div>
        )
      } else if(item.type === "gallery") {
        let img = []

        if (this.state[item.name] !== "") {
          img = this.state[item.name]
        }
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <Gallery image={ img } name={ item.name } onImageChange={ this.onImageChange } sessionId={ this.props.sessionId }/>
          </div>
        )
      } else if (item.type === "products") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <Tags API={ this.props.API } tags={ this.state.productList !== "" ? this.state.productList : [] } onTagsChange={ this.onTagsChange }/>
            <div className="tag-management"><NavLink to="/produkty-finansowe">Zarządzaj produktami</NavLink></div>
          </div>
        )
      } else if (item.type === "additional_fields") {
        return (
          <div key={ i }>
            { this.state.additional_fields ? <AdditionalFields templates={ this.props.templates } template={ this.state.template } fields={ this.state.additional_fields } additionalFieldsChange={ this.additionalFieldsChange }/> : null }
          </div>
        )
      } else if (item.type === "barem") {
        return (
          <div key={ i } className="title">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <BaremList user={ this.props.user } API={ this.props.API } barems={ this.state.baremList !== "" ? this.state.baremList : [] } onBaremChange={ this.onBaremChange } getData={ this.getData }/>
          </div>
        )
      } else if (item.type === "roles") {
        return (
          <div key={ i } className="title">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <Roles API={ this.props.API } user={ this.props.user } name={ item.name } onRoleChange={ this.onRoleChange } value={ this.state[item.name] }/>
          </div>
        )
      } else if (item.type === "passwd") {
        return (
          <div key={ i } className="title">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="password" name={ item.name } value={ this.state[item.name] } onChange={ this.handlePassChange } data-parsley-pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required={ item.required ? true : false }/>
            <p className="input-desc">Powtórz hasło</p>
            <input type="password" name="repeat" value={ this.state.repeat } onChange={ this.handlePassChange } data-parsley-pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required={ item.required ? true : false }/>
            { this.state.passerr ? <p className="error">Hasła są różne!</p> : null }
          </div>
        )
      } else if (item.type === "countMin") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <div className="withbtn"><button onClick={ this.countMin.bind(null, item.name, item.from) }>Wylicz</button><input type="text" name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }/></div>
          </div>
        )
      } else if (item.type === "countMax") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <div className="withbtn"><button onClick={ this.countMax.bind(null, item.name, item.from) }>Wylicz</button><input type="text" name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }/></div>
          </div>
        )
      } else if (item.type === "steps") {
        let steps = []
        let min = parseInt(this.state[item.from]) || 0
        let max = parseInt(this.state[item.to]) || 0
        let step = parseInt(this.state[item.step]) || 0
        let count = ((max - min) / step)
        if (max > 0 && step > 0 && min < max) {
          for (var j = 0; j <= count; j++) {
            steps.push(j)
          }
        }
        return (
          <div key={ "steps"+i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <select name={ item.name } onChange={ this.handleInputChange } value={ this.state[item.name] }>
              <option value="">Wybierz</option>
              { steps.map((item, k) => {
                return (
                  <option key={ k } value={ item }>{ item } - ({ item*step+min })</option>
                )
              })}
            </select>
          </div>
        )
      }
    })

    return (
      <section className="new">
        <div className="container">
          <h1>{ this.props.data.name } - edycja</h1>
          <form className="fields" data-parsley-validate>
            { this.props.user.role === "Administrator" || this.props.user.role === "Moderator" ? <div className="add-top" onClick={ this.add }>Zapisz zmiany</div> : null }
            <div className="back-top" onClick={ () => { this.props.history.goBack() } }>Powrót</div>
            { fields }
            { this.props.user.role === "Administrator" || this.props.user.role === "Moderator" ? <div className="add-bottom" onClick={ this.add }>Zapisz zmiany</div> : null }
            <div className="back-bottom" onClick={ () => { this.props.history.goBack() } }>Powrót</div>
            { this.state.preloader ? <div className="preloader"><span></span></div> : null }
          </form>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/EditPage.js